import gql from 'graphql-tag'

export const GET_CITIES = gql`
  query FindCity($countryUuid: ID, $searchTerm: String, $pageSize: Int) {
    findCity(countryUuid: $countryUuid, searchTerm: $searchTerm, pageSize: $pageSize) {
      cities {
        uuid
        name
        default
        subdivision1Name
        country {
          uuid
          name
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/queries/GetCities.tsx